import { createImpressionEvent } from '../base';
import { GIG_DESCRIPTION_PARAMS } from '../constants';

export const createGigDescriptionImpressionEvent = (type) =>
    createImpressionEvent(type, GIG_DESCRIPTION_PARAMS);
